import { makeStyles } from '@material-ui/core';

import { neutral, orange } from 'shared/styles/colors';

export default makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    marginBottom: '0.5rem',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.75rem',
    width: '100%',
  },
  title: {
    margin: 0,
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: neutral[100],
    minWidth: 0,
  },
  scheduledTag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    backgroundColor: orange.D6,
    borderRadius: '1.25rem',
    padding: '0.125rem 0.5rem',
    flexShrink: 0,
  },
  scheduledTagIcon: {
    fontSize: '1rem',
    width: '1rem',
    height: '1rem',
    color: orange[70],
    flexShrink: 0,
  },
  scheduledTagText: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: orange[70],
  },
  productsCount: {
    margin: 0,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: neutral[80],
  },
});
